import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "esp26_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const choose = (choice) => {
    localStorage.setItem(KEY, choice);
    try {
      if (choice === "reject") window.posthog?.opt_out_capturing?.();
      else window.posthog?.opt_in_capturing?.();
    } catch (e) {
      /* analytics not loaded — ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/10 bg-[#0F172A]/95 px-4 py-4 backdrop-blur-md sm:px-6"
    >
      <div className="mx-auto flex max-w-5xl flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-orange-500/15 text-orange-400">
            <Cookie className="h-5 w-5" />
          </div>
          <p className="text-sm leading-relaxed text-slate-300">
            We use essential cookies to run ESP26 and optional analytics cookies to improve it. You can accept or reject
            non-essential cookies. Read our{" "}
            <Link to="/privacy" className="font-semibold text-orange-400 underline-offset-2 hover:underline">
              Privacy &amp; Cookie Policy
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <button
            data-testid="cookie-reject-button"
            onClick={() => choose("reject")}
            className="rounded-full border border-white/15 px-4 py-2 text-sm font-semibold text-slate-200 transition-colors hover:bg-white/10"
          >
            Reject non-essential
          </button>
          <button
            data-testid="cookie-accept-button"
            onClick={() => choose("accept")}
            className="rounded-full bg-orange-500 px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-orange-600"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};
